import React from 'react';
import PropTypes from 'prop-types';
import { Radio } from 'antd';

const ButtonGroup = props => (
  <Radio.Group
    disabled={props.disabled}
    onChange={e => props.onChange && props.onChange(e.target.value)}
    value={props.value}
    buttonStyle="solid"
    size={{
      sm: 'small',
      md: 'default',
      lg: 'large',
    }[props.size]}
  >
    {props.options.map(option => (
      <Radio.Button value={option.value}>{option.label}</Radio.Button>
    ))}
  </Radio.Group>
);


ButtonGroup.propTypes = {
  size: PropTypes.oneOf(['sm','md','lg']),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOf([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired
};

ButtonGroup.defaultProps = {
  type: 'default',
  onChange: null,
  disabled: false,
  size: 'md',
};

export default ButtonGroup;
